import { createAuthenticatedClient } from "../authenticatedClient";
import { API_BASE_URL } from "../config";
import type { ApiEndpoint, ClientKind } from "../config/integrationEndpoints";

const isMfeMode =
  typeof window !== "undefined" &&
  (window.location.hostname === "loopback" ||
    window.location.pathname.startsWith("/ECMv6") ||
    window.location.pathname.startsWith("/intelligence"));

export const onboardingBasePath = `${API_BASE_URL}/ispm/v1/spm/onboarding`;
export const hydraBasePath = `${API_BASE_URL}/ispm/hydra/v1/integration`;

export const idwAdminBasePath = isMfeMode
  ? `${API_BASE_URL}/idw/admin`
  : `${API_BASE_URL}/api/idw/admin`;

export const idwAdminV1BasePath = isMfeMode
  ? `${API_BASE_URL}/idw/v1/admin`
  : `${API_BASE_URL}/api/idw/v1/admin`;

export const onboardingClient = createAuthenticatedClient(onboardingBasePath);
export const hydraClient = createAuthenticatedClient(hydraBasePath);
export const idwAdminClient = createAuthenticatedClient(idwAdminBasePath);
export const idwAdminV1Client = createAuthenticatedClient(idwAdminV1BasePath);

/** Map a ClientKind from the endpoint config to its concrete HTTP client. */
export function resolveClient(kind: ClientKind) {
  switch (kind) {
    case "onboarding":
      return onboardingClient;
    case "hydra":
      return hydraClient;
    case "idwAdmin":
      return idwAdminClient;
    case "idwAdminV1":
      return idwAdminV1Client;
  }
}

/** Map a ClientKind to its absolute base URL (for fetch() calls that need it). */
export function resolveBaseUrl(kind: ClientKind): string {
  switch (kind) {
    case "onboarding":
      return onboardingBasePath;
    case "hydra":
      return hydraBasePath;
    case "idwAdmin":
      return idwAdminBasePath;
    case "idwAdminV1":
      return idwAdminV1BasePath;
  }
}

export async function callEndpoint<T>(
  endpoint: ApiEndpoint,
  body?: unknown,
): Promise<T> {
  const client = resolveClient(endpoint.client);
  switch (endpoint.method) {
    case "GET":
      return client.get<T>(endpoint.path);
    case "POST":
      return client.post<T>(endpoint.path, body);
    case "PUT":
      return client.put<T>(endpoint.path, body);
    case "DELETE":
      return client.delete<T>(endpoint.path);
  }
}
